import { render, staticRenderFns } from "./BetgameEditTeamsCompetitions.vue?vue&type=template&id=43cf4b5b&scoped=true"
import script from "./BetgameEditTeamsCompetitions.vue?vue&type=script&lang=js"
export * from "./BetgameEditTeamsCompetitions.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditTeamsCompetitions.vue?vue&type=style&index=0&id=43cf4b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf4b5b",
  null
  
)

export default component.exports